import LayoutPadrao from 'lg-vue-components/layoutPadrao'

export default [
   {
      path: '/',
      redirect: 'home',
      component: LayoutPadrao,
      children: [
         {
            path: '/home',
            name: 'home',
            component: () => import('../pages/PaginaInicial.vue')
         }
      ]
   }
]
